import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { push } from "react-router-redux"
import { Route, Link, Switch } from "react-router-dom"
import { Slider, Select, Button, Col, Row } from "antd"

// import Integrations from "./Integrations"
import Card, { TitleCard } from "../../core/Card"
import All from "./All"
import {
  enableFreshbooks,
  disableFreshbooks,
  enableXero,
  disableXero
} from "./actions"
import onMount from "../../core/onMount"
import freshbooksIcon from "./FreshbooksIcon.png"
import xeroIcon from "./XeroIcon.png"

export const getIntegrationIcon = integration => {
  switch (integration) {
    case "freshbooks":
      return freshbooksIcon //"https://lh3.ggpht.com/RN93jsS95_cgM8X7fiHf_OKONepq1QE2vNt3RckDWzoLqG_I_CWuJEFHbmNKT1H2fA=s360-rw"

    case "xero":
      // return XeroSvg
      return xeroIcon //"https://lh3.googleusercontent.com/YTKzzWhHIpOtr5nx6jZoPjuY3UxFaDhaIdGwBgV23rzwc3RS8W78ARvh_u06HcUOQNI=s360-rw"

    default:
      return ""
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { enableFreshbooks, disableFreshbooks, enableXero, disableXero },
    dispatch
  )
}

const mapStateToProps = ({
  models: {
    user: { integration_accounts, integrations_enabled, token_id }
  }
}) => {
  return {
    integrations_enabled,
    integration_accounts,
    userTokenId: token_id
  }
}
export const AllIntegrations = connect(
  mapStateToProps,
  mapDispatchToProps
)(All)

export const withCardLayout = WrappedComponent => props => (
  <div>
    <TitleCard sticky>
      <h1>Integrations</h1>
    </TitleCard>
    <Card>
      <WrappedComponent {...props} />
    </Card>
  </div>
)

export default props => (
  <Switch>
    <Route
      exact
      path={`/account/integrations`}
      component={withCardLayout(AllIntegrations)}
    />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/account/integrations/index.js